import ActionTypes from "../constants/ActionTypes";

export function setNavHeight(height) {
    return {
        type: ActionTypes.SET_NAV_HEIGHT,
        height,
    };
}

export function hideNav() {
    return {
        type: ActionTypes.HIDE_NAV,
    };
}

export function showNav() {
    return {
        type: ActionTypes.SHOW_NAV,
    };
}

export function invertNav() {
    return {
        type: ActionTypes.INVERT_NAV,
    };
}

export function uninvertNav() {
    return {
        type: ActionTypes.UNINVERT_NAV,
    };
}

export function openAccountModal() {
    return {
        type: ActionTypes.OPEN_ACCOUNT_MODAL,
    };
}

export function unopenAccountModal() {
    return {
        type: ActionTypes.UNOPEN_ACCOUNT_MODAL,
    };
}

export function openAlertModal(title: string, message: string) {
    return {
        type: ActionTypes.OPEN_ALERT_MODAL,
        title,
        message,
    };
}

export function unopenAlertModal() {
    return {
        type: ActionTypes.UNOPEN_ALERT_MODAL,
    };
}

export function setCheckoutNav() {
    return {
        type: ActionTypes.SET_CHECKOUT_NAV,
    };
}

export function unsetCheckoutNav() {
    return {
        type: ActionTypes.UNSET_CHECKOUT_NAV,
    };
}

export function setSimpleNav() {
    return {
        type: ActionTypes.SET_SIMPLE_NAV,
    };
}

export function unsetSimpleNav() {
    return {
        type: ActionTypes.UNSET_SIMPLE_NAV,
    };
}

export function setNoNav() {
    return {
        type: ActionTypes.SET_NO_NAV,
    };
}

export function unsetNoNav() {
    return {
        type: ActionTypes.UNSET_NO_NAV,
    };
}

export function hideSignupFooter() {
    return {
        type: ActionTypes.HIDE_SIGNUP_FOOTER,
    };
}

export function showSignupFooter() {
    return {
        type: ActionTypes.SHOW_SIGNUP_FOOTER,
    };
}

export function setHistoryGoBack(goBack) {
    return {
        type: ActionTypes.SET_HISTORY_BACK,
        goBack,
    };
}

export function clearHistoryGoBack() {
    return {
        type: ActionTypes.CLEAR_HISTORY_BACK,
    };
}

export function closeAllModals() {
    return {
        type: ActionTypes.CLOSE_ALL_MODALS,
    };
}
